import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { User } from 'oidc-client';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { delayedRetryHttp } from './shared/delayedRetry';
import { UtilityService } from './shared/utility.service';

import { ContactList, ContactListResponse } from '../models/contact.model';
import { Item, Search, SearchItem, SearchItemListResponse, SearchListResponse, SearchQuery, SearchQueryResponse, HomeSearchResponse, ContactSearchReq, PowerSearchFilterResponse, PowerSearchRequest, ContactSearchRequest, PowerSearchSaveRequest, PowerSearchRes} from '../models/search.model';
import { SimpleResponse } from '../models/genericResponse.model';
import { isNullOrUndefined } from 'util';
import { CompanyListResponse } from '../models/company.model';
import { eCustomSearchCategory } from '../models/enum.model';
import { CustomSearchResponse } from '../models/report.model';



@Injectable({
  providedIn: 'root'
})

export class SearchContactService {

  private baseUrl: string;
  private baseUrlCompany: string;
  private baseUrlLead: string;
  private api: string = "api/Search";
  private apiComp: string = "api/SearchCompany";
  private apiLead: string = "api/LeadSetting";

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
    this.baseUrlCompany = _baseUrl + this.apiComp;
    this.baseUrlLead = _baseUrl + this.apiLead;
  }


  async getSearchFields(encryptedUser: string, clpCompanyId: number): Promise<SearchItemListResponse | void> {
    const a = await this.httpClient
        .get<SearchItemListResponse>(`${this.baseUrl}/Search_Filter_GET/${clpCompanyId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpCompanyId - " + clpCompanyId, encryptedUser, "SearchContactService", "getSearchFields"); });
    return a;
  }

    async getCompanySearchFields(encryptedUser: string, userId: number, clpCompanyId: number): Promise<SearchItemListResponse | void> {
    const a = await this.httpClient
        .get<SearchItemListResponse>(`${this.baseUrlCompany}/Search_Filter_GET/${clpCompanyId}/${userId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "userId" + userId + "," + "clpCompanyId" + clpCompanyId , encryptedUser, "SearchContactService", "getCompanySearchFields"); });
    return a;
  }
  async searchSaveComany(encryptedUser: string, searchQueryResponseCompany: SearchQueryResponse, userId: number): Promise<CompanyListResponse | void> {
    const a = await this.httpClient
      .post<any[]>(`${this.baseUrlCompany}/Search/${userId}`, searchQueryResponseCompany, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, searchQueryResponseCompany, "r - " + encryptedUser + "," + "userId" + userId, encryptedUser, "SearchContactService", "searchSaveComany"); });
    return a;
  }

  getContactSearchAsync(encryptedUser: string, searchQuery: SearchQueryResponse, isArchive?: boolean): Observable<ContactListResponse | void> {
    var a;
    if (!isNullOrUndefined(isArchive)) {
      a = this.httpClient.post<SearchQueryResponse>(`${this.baseUrl}/ContactSearch/${isArchive}`, searchQuery, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(
        delayedRetryHttp(),
        catchError(error => this._utilityService.handleErrors(error, null, "r - " + encryptedUser + "," + "isArchive" + isArchive , encryptedUser, "SearchContactService", "getContactSearchAsync")),
      );
    }
    else {
       a = this.httpClient.post<SearchQueryResponse>(`${this.baseUrl}/ContactSearch`, searchQuery, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(
        delayedRetryHttp(),
        catchError(error => this._utilityService.handleErrors(error, null, "r - " + encryptedUser , encryptedUser, "SearchContactService", "getContactSearchAsync")),
      );
    }
    return a;
  }

  async SavedSearchQueries_Update(encryptedUser: string, searchQuery: SearchQueryResponse, userID: number, queryId: number, savedQueryName: string, searchCategory: eCustomSearchCategory = eCustomSearchCategory.Contact): Promise<SimpleResponse | void> {
    const a = await this.httpClient.post<SearchQueryResponse>(`${this.baseUrl}/SavedSearchQueries_Update/${userID}/${queryId}/${encodeURIComponent(savedQueryName)}?searchCategory=${searchCategory}`, searchQuery, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, searchQuery, "r - " + encryptedUser + "," + "userID" + userID + "," + "queryId" + queryId + "," + "savedQueryName" + savedQueryName + "," + "searchCategory" + searchCategory , encryptedUser, "SearchContactService", "SavedSearchQueries_Update"); });
    return a;
  }

  async executeSavedQuery(encryptedUser: string, queryId: number, isArchive?: boolean): Promise<ContactListResponse | void> {
    var a;
    if (!isNullOrUndefined(isArchive)) {
       a = await this.httpClient
         .get<ContactListResponse>(`${this.baseUrl}/ExecuteSavedQuery/${queryId}/${isArchive}`, {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + encryptedUser
          })
         }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "queryId" + queryId + "," + "isArchive" + isArchive , encryptedUser, "SearchContactService", "executeSavedQuery"); });
    }
    else {
       a = await this.httpClient
         .get<ContactListResponse>(`${this.baseUrl}/ExecuteSavedQuery/${queryId}`, {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + encryptedUser
          })
         }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "queryId" + queryId , encryptedUser, "SearchContactService", "executeSavedQuery"); });
    }   
    return a;
  }

  async getSavedSearhById(encryptedUser: string, queryId: number): Promise<SearchQueryResponse | void> {
    const a = await this.httpClient
      .get<SearchQueryResponse>(`${this.baseUrl}/GetSavedSearhById/${queryId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "queryId" + queryId , encryptedUser, "SearchContactService", "getSavedSearhById"); });
    return a;
  }

  async savedSearchQueries_Delete(encryptedUser: string, userID: number, queryId: number, searchCategory: eCustomSearchCategory = eCustomSearchCategory.Contact): Promise<SimpleResponse | void> {
    const a = await this.httpClient.get<SearchQueryResponse>(`${this.baseUrl}/DeleteSavedSearhById/${queryId}/${userID}?searchCategory=${searchCategory}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "queryId" + queryId + "," + "userID" + userID + "," + "searchCategory" + searchCategory, encryptedUser, "SearchContactService", "savedSearchQueries_Delete"); });
    return a;
  }

    async getLeadSearchFields(encryptedUser: string, userId: number, clpCompanyId: number): Promise<SearchItemListResponse | void> {
    const a = await this.httpClient
        .get<SearchItemListResponse>(`${this.baseUrlLead}/LeadSearch_Filter_GET/${clpCompanyId}/${userId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpCompanyId" + clpCompanyId + "," + "userId" + userId, encryptedUser, "SearchContactService", "getLeadSearchFields"); });
    return a;
  }

  async getContactSearchData(encryptedUser: string, userId: number, search: Search): Promise<SearchListResponse | void> {
    const a = await this.httpClient
      .post<SearchListResponse>(`${this.baseUrl}/GetSearchData/${userId}`, search, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, search, "r - " + encryptedUser + "," +  "userId" + userId, encryptedUser, "SearchContactService", "getContactSearchData"); });
    return a;
  }

  async getHomeSearch(encryptedUser: string, clpCompanyId: number, clpUserID: number, selectedOption: string, blnIsMine: boolean, searchTxt: string): Promise<HomeSearchResponse | void> {
    const a = await this.httpClient
      .get<HomeSearchResponse>(`${this.baseUrl}/HomeSearch/${clpCompanyId}/${clpUserID}/${selectedOption}/${blnIsMine}?searchTxt=${searchTxt}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpCompanyId" + clpCompanyId + "," + "clpUserID" + clpUserID + "," + "selectedOption" + selectedOption + "," + "blnIsMine" + blnIsMine + "," + "searchTxt" + searchTxt, encryptedUser, "SearchContactService", "getHomeSearch");});
    return a;
    }

    async contactSearchNew(encryptedUser: string, clpUserId: number, clpCompanyID: number, contactSearchReq: ContactSearchReq): Promise<ContactListResponse | void> {
        const a = await this.httpClient
            .post<ContactListResponse>(`${this.baseUrl}/ContactSearchNew/${clpUserId}/${clpCompanyID}`, contactSearchReq, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, contactSearchReq, "r - " + encryptedUser + "," + "userId" + clpUserId + "," + "clpCompanyID" + clpCompanyID, encryptedUser, "SearchContactService", "contactSearchNew"); });
        return a;
    }

    async contactSearchDisplay(encryptedUser: string, isArchive: boolean, searchQueryResponse: SearchQueryResponse): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/ContactSearchDisplay/${isArchive}`, searchQueryResponse, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, searchQueryResponse, "r - " + encryptedUser, encryptedUser, "SearchContactService", "contactSearchNew"); });
        return a;
    }


    async saveCustomContactSearchNew(encryptedUser: string, clpUserId: number, clpCompanyID: number, displayName: string, contactSearchReq: ContactSearchReq): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/SaveCustomContactSearchNew/${clpUserId}/${clpCompanyID}?displayName=${displayName}`, contactSearchReq, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, contactSearchReq, "r - " + encryptedUser + "," + "userId" + clpUserId + "," + "clpCompanyID" + clpCompanyID, encryptedUser, "SearchContactService", "contactSearchNew"); });
        return a;
    }

    async customSearchs_GetList(encryptedUser: string, clpUserId: number, clpCompanyID: number, objectType: number, isSavedSearch: boolean): Promise<CustomSearchResponse[] | void> {
        const a = await this.httpClient
            .get<CustomSearchResponse []>(`${this.baseUrl}/CustomSearchs_GetList/${clpCompanyID}/${clpUserId}/${objectType}/${isSavedSearch} `, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "userId" + clpUserId + "," + "clpCompanyID" + clpCompanyID, encryptedUser, "SearchContactService", "contactSearchNew"); });
        return a;
    }

    async customSearch_Get(encryptedUser: string, clpUserId: number, filterValue: string): Promise<ContactListResponse | void> {

        const a = await this.httpClient
            .get<ContactListResponse>(`${this.baseUrl}/CustomSearch_Get/${clpUserId}/${filterValue}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpUserId:-" + clpUserId + "," + "filterValue:-" + filterValue, encryptedUser, "SearchContactService", "CustomSearch_Get"); });
        return a;
    }

    async getContact_NewSearchCount(encryptedUser: string, customSearchId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/GetContact_NewSearchCount/${customSearchId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "customSearchId" + customSearchId , encryptedUser, "SearchContactService", "contactSearchNew"); });
        return a;
    }

    async getContact_NewSearchResult(encryptedUser: string, customSearchId: number,clpuserId : number, useExtendedSearch: boolean = false): Promise<ContactListResponse | void> {
        const a = await this.httpClient
            .get<ContactListResponse>(`${this.baseUrl}/GetContact_NewSearchResult/${customSearchId}/${clpuserId}/${useExtendedSearch}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "customSearchId" + customSearchId, encryptedUser, "SearchContactService", "GetContact_NewSearchResult"); });
        return a;
    }

    async contact_deleteCustomSearch(encryptedUser: string, customSearchId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/Contact_DeleteCustomSearch/${customSearchId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "customSearchId" + customSearchId, encryptedUser, "SearchContactService", "Contact_deleteCustomSearch"); });
        return a;
    }

    async getPowerSearchFields(encryptedUser: string, clpCompanyId: number): Promise<PowerSearchFilterResponse | void> {
        const a = await this.httpClient
            .get<PowerSearchFilterResponse>(`${this.baseUrl}/PowerSearch_Filter_GET/${clpCompanyId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpCompanyId - " + clpCompanyId, encryptedUser, "SearchContactService", "getPowerSearchFields"); });
        return a;
    }

    async engageMetric_Search_Filter_GET(encryptedUser: string, clpCompanyId: number): Promise<SearchItemListResponse | void> {
        const a = await this.httpClient
            .get<SearchItemListResponse>(`${this.baseUrl}/EngageMetric_Search_Filter_GET/${clpCompanyId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpCompanyId - " + clpCompanyId, encryptedUser, "SearchContactService", "engageMetric_Search_Filter_GET"); });
        return a;
    }

    async calculateRecordCount(encryptedUser: string, requestObj: PowerSearchRequest, clpCompanyId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/CalculateRecordCount/${clpCompanyId}`, requestObj, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, requestObj, "r - " + encryptedUser + "," + "clpCompanyId" + clpCompanyId, encryptedUser, "SearchContactService", "calculateRecordCount"); });
        return a;
    }

    async GetContact_SearchResult(encryptedUser: string, clpUserId: number, clpCompanyID: number, contactSearchReq: ContactSearchRequest): Promise<ContactListResponse | void> {
        const a = await this.httpClient
            .post<ContactListResponse>(`${this.baseUrl}/GetContact_SearchResult/${clpCompanyID}/${clpUserId}`, contactSearchReq, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, contactSearchReq, "r - " + encryptedUser + "," + "userId" + clpUserId + "," + "clpCompanyID" + clpCompanyID, encryptedUser, "SearchContactService", "GetContact_SearchResult"); });
        return a;
    }
    async SavePowerSearch(encryptedUser: string, clpUserId: number, clpCompanyID: number, searchReq: PowerSearchSaveRequest): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/SavePowerSearch/${clpUserId}/${clpCompanyID}`, searchReq, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, searchReq, "r - " + encryptedUser + "," + "userId" + clpUserId + "," + "clpCompanyID" + clpCompanyID, encryptedUser, "SearchContactService", "SavePowerSearch"); });
        return a;
    }

    async PowerSearch_Load(encryptedUser: string, customSearchID: number): Promise<PowerSearchRes | void> {
        const a = await this.httpClient
            .get<PowerSearchRes>(`${this.baseUrl}/PowerSearch_Load/${customSearchID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "customSearchID - " + customSearchID, encryptedUser, "SearchContactService", "engageMetric_Search_Filter_GET"); });
        return a;
    }
}
